import React, { useState } from 'react';
import Rating from '@material-ui/lab/Rating';
import { Typography, Box } from '@material-ui/core';

const UserRating = () => {
    const [value, setValue] = useState(2);

    return (
        <>
            <Box component="fieldset" mb={3} borderColor="transparent" style={{display: 'flex', alignItems:"center", justifyContent:"center"}}> 
                {/* <Typography component="legend">4.0</Typography> */}
                <Rating name="simple-controlled" value={value} onChange={(event, newValue) => {setValue(newValue);}}/>
            </Box>
        </>
    );
}

export default UserRating;